import React, { useRef, useCallback } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { dateOnlyBodyTemplate } from '../../../../../utils/dateUtils';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const VehicleAcceptanceTable = ({ items, lazyParams, totalRecords, loading, onPage, handleEdit, onSort, tabLabel, currentStatus, handleShowHistory, th }) => {
    const dataTableRef = useRef(null);
    const columnsRef = useRef(null);

    const getColumnsCallback = useCallback((el) => {
        if (el && el.getColumns && !columnsRef.current) {
            columnsRef.current = el.getColumns();
        }
        dataTableRef.current = el;
    }, []);

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="flex gap-2 justify-content-center">
                <i className="pi pi-pencil cursor-pointer text-blue-500 hover:text-blue-700" style={{ fontSize: '1.1rem' }} title={th('common.edit')} onClick={() => handleEdit(rowData)} />
                <i className="pi pi-history cursor-pointer text-blue-500 hover:text-blue-700" style={{ fontSize: '1.1rem' }} title={th('warranty.vehicleAcceptanceForm.tooltips.history')} onClick={() => handleShowHistory(rowData)}></i>
            </div>
        );
    };

    const kilometerBodyTemplate = (rowData) => {
        return rowData.vehicleAcceptKm ? rowData.vehicleAcceptKm.toLocaleString('tr-TR') + ' km' : '';
    };

    const isVisible = (field) => {
        const rules = {
            returnMsg: [th('warranty.vehicleAcceptanceForm.tabs.returned')],
            status: true
        };
        return !rules[field] || rules[field] === true || (Array.isArray(rules[field]) && rules[field].includes(tabLabel));
    };

    const header = (
        <div className="flex align-items-center gap-3">
            <h3 className="text-xl font-semibold text-900 m-0">
                <i className="pi pi-list mr-2 text-primary"></i>
                {th('warranty.vehicleAcceptanceForm.table.title')}
            </h3>
        </div>
    );

    return (
        <DataTable
            value={items}
            lazy
            paginator
            first={lazyParams.first}
            rows={lazyParams.rows}
            onPage={onPage}
            onSort={onSort}
            sortField={lazyParams.sortField}
            sortOrder={lazyParams.sortOrder}
            totalRecords={totalRecords}
            loading={loading}
            emptyMessage={th('warranty.vehicleAcceptanceForm.table.emptyMessage')}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            dataKey="id"
            tableStyle={{ minWidth: '80rem' }}
            showGridlines
            stripedRows
            className="p-datatable-gridlines"
            filterDisplay="menu"
            globalFilterFields={['chassisNo', 'customerName', 'description']}
            header={header}
            ref={getColumnsCallback}
        >
            <Column body={actionBodyTemplate} exportable={false} style={{ width: '5%', minWidth: '80px' }} frozen alignFrozen="left" bodyClassName="text-center" headerClassName="text-center" />
            <Column field='bosBranchCode' header={th('warranty.vehicleAcceptanceForm.table.bosBranchCode')} sortable style={{ minWidth: '150px' }} />
            <Column field="bosBranchCodeName" header={th('warranty.vehicleAcceptanceForm.table.bosBranchCodeName')} sortable style={{ minWidth: '150px' }} />
            <Column field="country" header={th('warranty.vehicleAcceptanceForm.table.country')} sortable style={{ minWidth: '150px' }} />
            <Column field="chassisNo" header={th('warranty.vehicleAcceptanceForm.table.chassisNo')} sortable style={{ minWidth: '150px' }} />
            <Column field="vehicleAcceptDate" header={th('warranty.vehicleAcceptanceForm.table.vehicleAcceptDate')} sortable body={(rowData) => dateOnlyBodyTemplate(rowData, 'vehicleAcceptDate')} style={{ minWidth: '150px' }} />
            <Column field='createdDate' header={th('warranty.vehicleAcceptanceForm.table.createdDate')} sortable body={(rowData) => dateOnlyBodyTemplate(rowData, 'createdDate')} style={{ minWidth: '150px' }} />
            {isVisible('returnMsg') && <Column field="returnMsg" header={th('warranty.vehicleAcceptanceForm.table.returnMsg')} sortable style={{ minWidth: '200px' }} />}
        </DataTable>
    );
};

export default VehicleAcceptanceTable;